var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("VueGoodTable", {
        ref: "table",
        attrs: {
          columns: _vm.columns,
          rows: _vm.state.templatesStore.templates,
          "pagination-options": _vm.paginationOptions,
          "search-options": _vm.searchOptions
        },
        on: { "on-row-click": _vm.onClick },
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function(props) {
              return [
                props.column.field === "actions"
                  ? [
                      _vm.editable
                        ? _c(
                            "div",
                            {
                              staticClass: "btn-group",
                              attrs: { role: "group" }
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary btn-sm",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      $event.stopPropagation()
                                      return _vm.onEdit(props.row)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fas fa-pen" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-danger btn-sm",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      $event.stopPropagation()
                                      return _vm.onDelete(props.row)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fas fa-trash-alt" })]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  : _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.formattedRow[props.column.field]) +
                          "\n      "
                      )
                    ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _vm.editable
        ? _c(
            "button",
            {
              staticClass: "btn btn-success mt-2 ml-1",
              attrs: { type: "button" },
              on: { click: _vm.createNew }
            },
            [_vm._v("\n    " + _vm._s(_vm.$t("btnAdd")) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("MeasurementSpecificationTemplateEditModal", {
        ref: "editModal",
        attrs: { editable: _vm.editable }
      }),
      _vm._v(" "),
      _c("MeasurementSpecificationTemplateDeleteModal", { ref: "deleteModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }